export const colorRule = (color = {}) => ({
  stockStatus: color.stock_status === 'made_to_order' ? 'made_to_order' : 'ready',
  moq: Math.max(1, Number(color.moq) || 1),
  step: Math.max(1, Number(color.moq_step) || 1),
});

export const matrixKey = (colorIndex, size) => `${colorIndex}::${size}`;

export const readMatrixKey = (key) => {
  const splitAt = key.indexOf('::');
  return {
    colorIndex: Number(key.slice(0, splitAt)),
    size: key.slice(splitAt + 2),
  };
};

// Total pieces selected for a colour, summed across its per-size selectors.
export const colorTotalQty = (color, colorIndex, sizes, qtyMatrix) => {
  return (sizes || []).reduce((sum, size) => sum + (Number(qtyMatrix[matrixKey(colorIndex, size)]) || 0), 0);
};

export const validateColorOrder = (product, qtyMatrix) => {
  const errors = [];
  (product.colors || []).forEach((color, colorIndex) => {
    const rule = colorRule(color);
    const isReady = rule.stockStatus === 'ready';
    const total = colorTotalQty(color, colorIndex, product.sizes, qtyMatrix);
    if (total > 0 && total < rule.moq) {
      errors.push(`${color.name}: minimum ${rule.moq} pcs required (${rule.moq - total} more)`);
    }
    // Ready Stock: MOQ met -> any +1 quantity allowed (no step rule).
    // Made to Order: single bulk quantity must follow the colour's Step MOQ.
    if (!isReady && total > 0 && total % rule.step !== 0) {
      errors.push(`${color.name}: quantity must be in steps of ${rule.step}`);
    }
  });
  return errors;
};